// vip 路由
import {loadPageFail} from '../lib/units';

export default [
    {
        name: 'member',
        path: '/member',
        meta: {
            title: '会员购买成功页 ',
            newZhugeTitle: '会员年卡活动',
            fullTitle:function(){
                return '支付成功 ';
            }
        },
        component: resolve => require(['../pages/member/member.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '会员购买成功页',
                err
            });
        })
    },
    {
        name: 'memberreceive',
        path: '/memberreceive',
        meta: {
            title: '红包领取页',
            newZhugeTitle: '会员年卡活动',
            fullTitle:function(){
                return '领红包';
            }
        },
        component: resolve => require(['../pages/member/memberReceive.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '红包领取页',
                err
            });
        })
    },
    {
        name: 'activityDistribution',
        path: '/activityDistribution',
        meta: {
            title: '分销页',
            newZhugeTitle: '分销页',
            fullTitle:function(){
                return '分销页';
            }
        },
        component: resolve => require(['../pages/member/activityDistribution.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '分销页',
                err
            });
        })
    },
    {
        name: 'myDistribution',
        path: '/myDistribution',
        meta: {
            title: '我的分享',
            newZhugeTitle: '会员年卡活动',
            fullTitle:function(){
                return '我的分享';
            }
        },
        component: resolve => require(['../pages/member/myDistribution.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '我的分享',
                err
            });
        })
    },
    {
        name: 'memberActivty',
        path: '/memberActivty',
        meta: {
            title: '会员活动专场',
            newZhugeTitle: '会员年卡活动',
            fullTitle:function(){
                return '活动主页';
            }
        },
        component: resolve => require(['../pages/member/memberActivty.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '会员活动专场',
                err
            });
        })
    },
    {
      name: 'vip-rights',
      path: '/vipRights',
      meta: {
        title: '会员权益页',
        newZhugeTitle: '会员年卡活动',
        fullTitle: function() {
          return '个人中心-会员中心';
        }
      },
      component: resolve => require(['../pages/member/vipRights'], resolve, (err)=>{
        loadPageFail({
          pagename: '会员权益页',
          err
        });
      })
    },
    {
      name: 'rank',
      path: '/rank',
      meta: {
        title: '排行榜',
        newZhugeTitle: '会员年卡活动',
        fullTitle: function() {
          return '分销排行榜';
        }
      },
      component: resolve => require(['../pages/member/earningRank'], resolve, (err)=>{
        loadPageFail({
          pagename: '排行榜',
          err
        });
      })
    },
    {
      name: 'callingcard',
      path: '/callingcard',
      meta: {
        title: '亲情卡',
        newZhugeTitle: '亲情卡',
        fullTitle: function() {
          return '亲情卡';
        }
      },
      component: resolve => require(['../pages/member/callingCardspage'], resolve, (err)=>{
        loadPageFail({
          pagename: '亲情卡',
          err
        });
      })
    },
]



// WEBPACK FOOTER //
// ./src/router/member.js